
import { createTheme } from "@mui/material";

const theme = createTheme({
  typography: {
    fontFamily: [
        'Nunito',
        'Noto Serif TC',
        'sans-serif'
      ].join(','),
    },
    palette: {
      primary: {
        light: '#a4c08f',
        main: '#1c8231',
        dark: '#486236',
        contrastText: '#000',
      },
      secondary: {
        light: '#ff7961',
        main: '#f44336',
        dark: '#ba000d',
        contrastText: '#000',
      },
    },
  });

export default theme;
